var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.graph)?_c('graph',{attrs:{"payload":_vm.graph},on:{"click-edit-button":_vm.clickEditButton,"click-delete-button":_vm.clickDeleteButton}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }